import * as React from 'react';
import { formilyReact } from '@cainiaofe/cn-ui';
var useField = formilyReact.useField, observer = formilyReact.observer, useFieldSchema = formilyReact.useFieldSchema;
export var CnFormArrayCard = observer(function (props) {
    var autoIncrementTitle = props.autoIncrementTitle, additionText = props.additionText, hasDeleteButton = props.hasDeleteButton;
    var field = useField();
    var schema = useFieldSchema();
    var tableProperties = {};
    React.useEffect(function () {
        field.setComponent('CnArrayTable');
        if (autoIncrementTitle) {
            tableProperties.index = {
                type: 'void',
                'x-component': 'CnArrayTableColumn',
                'x-component-props': {
                    width: 120,
                    title: autoIncrementTitle,
                    align: 'center',
                },
                properties: {
                    index: {
                        type: 'void',
                        'x-component': 'CnArrayTableIndex',
                    },
                },
            };
        }
        schema.items.mapProperties(function (propertyItem) {
            var _a;
            tableProperties[propertyItem.name + 'column'] = {
                type: 'void',
                'x-component': 'CnArrayTableColumn',
                'x-component-props': {
                    title: propertyItem.title,
                },
                properties: (_a = {},
                    _a[propertyItem.name] = {
                        'x-decorator': propertyItem['x-decorator'],
                        'x-component': propertyItem['x-component'],
                        'x-component-props': propertyItem['x-component-props'],
                    },
                    _a),
            };
        });
        if (hasDeleteButton) {
            tableProperties.operation = {
                type: 'void',
                'x-component': 'CnArrayTableColumn',
                'x-component-props': {
                    width: 120,
                },
                properties: {
                    item: {
                        type: 'void',
                        'x-component': 'CnFormItem',
                        properties: {
                            remove: {
                                type: 'void',
                                'x-component': 'CnArrayTableRemove',
                            },
                        },
                    },
                },
            };
        }
        schema.setItems({
            type: 'object',
            properties: tableProperties,
        });
        if (additionText) {
            schema.setProperties({
                add: {
                    type: 'void',
                    title: additionText,
                    'x-component': 'CnArrayTableAddition',
                },
            });
        }
    }, [field, schema, additionText, autoIncrementTitle]);
    return React.createElement("div", null);
});
CnFormArrayCard.displayName = 'CnFormArrayCard';
CnFormArrayCard.defaultProps = {
    hasDeleteButton: true,
};
